import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { subcategoryService } from "services/subcategory.service";
import authStore from "stores/auth/AuthStore";
import { Subcategory } from "types/subcategory.type";

class SubcategoryStore {
  subcategories: Subcategory[] = [];
  loadingFetch = false;
  loadingAction = false;

  constructor() {
    makeAutoObservable(this);
  }
  async fetchSubcategories() {
    if (!authStore.isAuthenticated()) return;

    this.loadingFetch = true;
    try {
      const data = await subcategoryService.getAll();
      runInAction(() => {
        this.subcategories = data;
      });
    } catch (error: any) {
      if (
        error?.response?.data?.type === "role_changed" ||
        error?.response?.data?.type === "account_inactive"
      ) {
        return;
      }
      toast.error("Erreur lors du chargement des sous-catégories");
    } finally {
      runInAction(() => {
        this.loadingFetch = false;
      });
    }
  }
  async saveSubcategory(data: Partial<Subcategory>) {
    this.loadingAction = true;
    try {
      if (data.id) {
        const response = await subcategoryService.update(data.id, data);
        const updated: Subcategory = response?.data;
        runInAction(() => {
          const index = this.subcategories.findIndex((s) => s.id === data.id);
          if (index !== -1) this.subcategories[index] = updated;
        });
        await subcategoryService.update(data.id, data);
        toast.success("Sous-catégorie mise à jour !");
      } else {
        const response = await subcategoryService.create(data);
        const created: Subcategory = response?.data;
        runInAction(() => {
          this.subcategories.unshift(created);
        });
        toast.success("Sous-catégorie créée !");
      }
    } catch (error) {
      // toast.error("Erreur lors de l'enregistrement");
      throw error;
    } finally {
      runInAction(() => {
        this.loadingAction = false;
      });
    }
  }

  async deleteSubcategory(id: number) {
    this.loadingAction = true;
    try {
      await subcategoryService.delete(id);
      runInAction(() => {
        this.subcategories = this.subcategories.filter((s) => s.id !== id);
      });
      toast.success("Sous-catégorie supprimée !");
    } catch (error) {
      toast.error("Erreur lors de la suppression");
    } finally {
      runInAction(() => {
        this.loadingAction = false;
      });
    }
  }
}

const subcategoryStore = new SubcategoryStore();
export default subcategoryStore;
